import { DEFAULT_MAX_ACCESS_DURATION } from "@p0security/shared/configuration/constant";

import { DurationSetting } from "./DurationSetting.tsx";

export const MaxAccessDuration: React.FC = () => (
  <DurationSetting
    description="Set the maximum allowable duration for access requests."
    field="maxAccessDuration"
    fallback={DEFAULT_MAX_ACCESS_DURATION}
    label="Maximum access duration"
    route="settings/max-access-duration"
  />
);
